import React from 'react'

import { EntityTableCell } from '@fourthwall/components'
import type { AvailableRole } from '@hooks/useAvailableRoles'

import * as S from './RoleListItem.styled'

type RoleListItemProps = {
  role: AvailableRole
}

export const RoleListItem = ({ role }: RoleListItemProps) => {
  return (
    <S.Container>
      <EntityTableCell top={role.name} bottom={`${role.membersCount} members assigned`} />
    </S.Container>
  )
}
